jQuery(document).ready(markerInit);

function markerInit(){
	
	setupMarkerGoogleMaps();
    setupFeaturedCarouselMarkers();
    setupResourcesAnchorScroll();
    setupMarkerIconTooltips();
	
}

function setupMarkerGoogleMaps(){
    
    if(!jQuery('#single-marker-map').length) return false;
        
    var lat = parseFloat(markerMapInfo.lat);
    var lng = parseFloat(markerMapInfo.lng);
        
    var map = new google.maps.Map(document.getElementById('single-marker-map'), {
        center				: {lat: lat, lng: lng},
        zoom				: 10,
        mapTypeControl		: false,
        scaleControl		: false,
        streetViewControl	: false,
        rotateControl		: false,
        fullscreenControl	: false,
        styles  			: mapStyles
    });
    
    var markerWidth = 49;
    var markerHeight = 63;
    
    var marker = new google.maps.Marker({
        position	: {lat: lat, lng: lng},
        icon 		: { 
            url			: '/wp-content/themes/plumbweb-child/_assets/img/icon-map-pin.svg', 
            size		: new google.maps.Size(markerWidth, markerHeight), 
            scaledSize	: new google.maps.Size(markerWidth, markerHeight)
        },
        map			: map
    });
    
}

function setupFeaturedCarouselMarkers() {
    
    var carousel = jQuery('.slick.featured-markers');
    var showDots = jQuery('> div.slide-position', carousel).length > 1 ? true : false;
    
    carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        slidesPerRow: 1,
        dots: showDots,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        fade: false,
        easing: "linear",
        pauseOnHover: false,
        infinite: true,
        draggable: false,
        swipe: true,
        adaptiveHeight: true
    });
    
}

function setupResourcesAnchorScroll() {
    
    jQuery("#hom-anchor").on("click", function(){
        
        var homSection = jQuery(".wp-block-hom-resources").first();
        
        if(homSection.length) {
            jQuery("html, body").animate({ scrollTop: homSection.position().top }, "slow");
        }
        
    });
    
    jQuery("#resources-anchor").on("click", function(){
        
        var resourcesSection = jQuery(".wp-block-resource-box").first();
        
        if(resourcesSection.length) {
            jQuery("html, body").animate({ scrollTop: resourcesSection.position().top }, "slow");
        }
        
    });
    
}

function setupMarkerIconTooltips() {
    
    jQuery('.marker.tooltip').each(function(){
        
        var marker = jQuery(this);
        
        if(marker[0]._tippy){
            marker[0]._tippy.destroy();
        }
        
        tippy(marker[0], {
            theme		: 'wun',
            content		: marker.attr("data-tooltip"),
        });
        
    });
    
}
